import $ from 'jquery';

const addMenuOpenerInMobileMenu = () => {

    const $opener = $('.js-add-menu-opener');

    if ($opener.length < 1) {
        return;
    }

    const activeClass = 'active';

    $opener.on('click', function () {
        const $this = $(this);
        const $target = $this.closest('.js-add-menu-parent').find('.js-add-menu');
        $this.toggleClass(activeClass);
        $target.slideToggle();
    });

};

export default addMenuOpenerInMobileMenu;
